export const EquipmentStrings = {
  equipments: 'Equipment',
  loadingEquipmentList: 'Loading Equipment list...',
  equipmentListError: 'Cannot fetch Equipment list',
  kenNumber: 'KEN number',
  name: 'Name',
  organizations: 'Organizations',
  added: 'Added',
}
